import "app/app.css";
import UnauthenticatedApp from "app/UnauthenticatedApp";
import AuthorizedApp from "app/AuthorizedApp";
import { useAuth } from "app/Auth/AuthBoundary";
import { TrainLoader } from "app/TrainLoader";
import UnauthorizedApp from "app/UnauthorizedApp";
import { useDatadogRum } from "logging/useDatadogRum";
import { initDatadogBrowserLogs } from "logging/datadogBrowserLogs";

const App = () => {
  // Initialize RUM client
  useDatadogRum();
  initDatadogBrowserLogs();

  const { authState } = useAuth();

  switch (authState) {
    case "authorized":
      return <AuthorizedApp />;
    case "unauthorized":
      return <UnauthorizedApp />;
    case "unauthenticated":
      return <UnauthenticatedApp />;
    case "loading":
      return <TrainLoader />;
  }
};

export default App;
